import { eventAudienceParts } from "@/lib/sports";

// Inline event audience (B/G · grades · ages · grad years) where the dimension(s) the creator
// actually provided render in bold white, and auto cross-mapped ones stay muted.
// `lead` prepends " · " when there is anything to show (for use after the event type).
export function EventAudience({ e, lead = false, providedOnly = false }) {
    let parts = eventAudienceParts(e);
    if (providedOnly) {
        // Only filter down to the entered dimension(s) when we actually know which were provided;
        // otherwise fall back to everything so the line is never blank.
        const hasProvidedDim = parts.some((p) => p.provided && !p.gender);
        if (hasProvidedDim) parts = parts.filter((p) => p.gender || p.provided);
    }
    if (!parts.length) return null;
    return (
        <>
            {lead ? " · " : null}
            {parts.map((p, i) => (
                <span key={i}>
                    {i > 0 ? " · " : null}
                    <span className={p.provided ? "font-bold text-white" : ""}>{p.text}</span>
                </span>
            ))}
        </>
    );
}
